import LoginScreen from './LoginScreen'
import StoreLoginScreen from './StoreLoginScreen';
import AddAdvertisement from '../PublicStore/AddAdvertisement';
import ResetPassword from './ResetPassword'

export const LOGIN_ROUTE = "/login";
export const STORE_LOGIN_ROUTE = "/public/store/login";
export const STORE_NEW_ADVERTISEMENT_ROUTE = "/public/store/advertisement";
export const RESETPASSWORD_ROUTE = "/password/reset/:userId/:token";

export const routes = [
    {
        path: LOGIN_ROUTE,
        component: LoginScreen,
        exact: true,
        public: true
    },
    {
        path: STORE_LOGIN_ROUTE,
        component: StoreLoginScreen,
        exact: true,
        public: true
    },
    {
        path: STORE_NEW_ADVERTISEMENT_ROUTE,
        component: AddAdvertisement,
        exact: true,
        isStore: true
    },
    {
        path: RESETPASSWORD_ROUTE,
        component: ResetPassword,
        exact: true,
        public: true 
    }
];